module.exports = __webpack_public_path__ + "static/img/logo3.ebfd08d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo3.png
// module id = mCmD
// module chunks = 2